const logger = (message: string, error?: unknown) => {
  // eslint-disable-next-line no-console
  console.error(message, error);
};

export const setupLogger = () => {
  // catch promise unhandled rejections & errors
  window.addEventListener(
    'unhandledrejection',
    (error: PromiseRejectionEvent) => {
      error.preventDefault();

      logger('Unhandled rejection error', {
        customData: { error },
      });
    },
  );
};

export default logger;
